<template>
  <div class="multi-upload" :class="[{'multi-upload-margin-adjust': showInVerify}]">
    <div class="title" v-if="!showInVerify">
      <span>{{ title }}</span>
      <span v-if="tips" class="tips">{{ tips }}</span>
    </div>
    <div class="img-list" v-if="fileList">
      <div class="avatar"  @click="showPreview">
        <img :src="fileList" class="avatar-img"/>
        <i v-if="!disabled" class="el-icon-close" @click.stop="handleRemove"></i>
      </div>
    </div>
    <div v-else-if="disabled && !showInVerify" class="empty-list">暂无</div>
    <div v-else-if="disabled && showInVerify" class="img-list img-list-empty">
      暂无图片
    </div>
    <el-upload
      v-if="!fileList && !disabled"
      class="avatar-uploader"
      :disabled="disabled"
      :accept="'image/jpeg,image/png'"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      action="/workspace/manager/portal/upload/image"
      name="uploadFile"
      :before-upload="beforeAvatarUpload">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: ''
    }
  },
  props: {
    showInVerify: {
      default: false
    },
    title: {
      type: String,
      default: '上传图片'
    },
    value: {
      type: String,
      default: ''
    },
    tips: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAvatarSuccess (res) {
      if (res.errorCode === 0) {
        this.fileList = (res.uploadLink)
        this.$emit('input', this.fileList)
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJPG) {
        this.$message.error('上传图片只能是.jpg/.jpeg/.png格式!')
        return
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleRemove () {
      this.fileList = ''
      this.$emit('input', this.fileList)
    },
    showPreview () {
      this.dialogImageUrl = this.fileList
      this.$nextTick(() => {
        this.dialogVisible = true
      })
    }
  },
  watch: {
    value: {
      handler (val) {
        this.fileList = val
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.multi-upload {
  margin: 20px;
  display: flex;
  align-items: center;
  & > .title {
    color: #3373B5;
    font-weight: 550;
    font-size: 13px;
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    flex-shrink: 0;
    & > .tips {
      color: #999;
      font-size: 12px;
      margin-left: 8px;
    }
  }
  & > .img-list {
    display: flex;
    flex-wrap: wrap;
    & > .avatar {
      width: 150px;
      height: 150px;
      margin-right: 8px;
      margin-bottom: 8px;
      position: relative;
      cursor: pointer;
      & > .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      & > .el-icon-close {
        position: absolute;
        top: 8px;
        right: 8px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  & > .img-list-empty {
    width: 150px;
    height: 150px;
    margin-right: 8px;
    margin-bottom: 8px;
    position: relative;
    cursor: pointer;
    border: 1px dashed #5e5e5e70;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & > .empty-list {
    width: 100px;
    display: flex;
    justify-content: center;
    font-size: 12px;
  }
  ::v-deep  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}
.multi-upload-margin-adjust{
  margin: 0;
  width: 150px;
  height: 150px;
  margin-right: 10px;
  margin-top: 10px;
}
</style>
